// extracted by mini-css-extract-plugin
module.exports = {"positiveFeedback":"styles_positiveFeedback__2NGd1","passedIcon":"styles_passedIcon__2XsFG"};